
export enum ImageStrategy {
  None = 'none',
  Next = 'next',
  Mixer = 'mixer',
  Oven = 'oven',
  Token = 'token',
  Custom = 'custom',
}

export type IImageResize = {
  q: number;
  w: number;
  h?: number;
  x?: number;
  y?: number;
  src: string;
};
